import { render, staticRenderFns } from "./AStaffDetailClasses.vue?vue&type=template&id=c3bf4b76&scoped=true"
import script from "./AStaffDetailClasses.vue?vue&type=script&lang=js"
export * from "./AStaffDetailClasses.vue?vue&type=script&lang=js"
import style0 from "./AStaffDetailClasses.vue?vue&type=style&index=0&id=c3bf4b76&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3bf4b76",
  null
  
)

export default component.exports